import styles from "./styles.module.css";
import { useState, useEffect } from "react";

import Input from "../../../ui/input";

import AddDevices from "./add-devices";
const OrderIndividual = () => {
  const [isOpen, setIsOpen] = useState(true);

  const placeOrderHandler = () => {};
  return (
    <section>
      <section className={styles.shippingInfoContainer}>
        <section className={styles.shippingInfo}>
          <section className={styles.inputContainer}>
            <Input
              type="text"
              placeholder="first name"
              label="First Name"
              name="first_name"
              //   value={deviceDetails.quantity}
              //   onChange={(e) =>
              //     setDeviceDetails((prev) => ({
              //       ...prev,
              //       quantity: e.target.value,
              //     }))
              //   }
            />
            <Input
              type="text"
              placeholder="last name"
              label="Last Name"
              name="last_name"
              //   value={deviceDetails.quantity}
              //   onChange={(e) =>
              //     setDeviceDetails((prev) => ({
              //       ...prev,
              //       quantity: e.target.value,
              //     }))
              //   }
            />
          </section>
          <section className={styles.inputContainer}>
            <Input
              type="text"
              placeholder="patient id"
              label="Patient Id"
              name="patient_id"
              //   value={deviceDetails.quantity}
              //   onChange={(e) =>
              //     setDeviceDetails((prev) => ({
              //       ...prev,
              //       quantity: e.target.value,
              //     }))
              //   }
            />
            <Input
              type="number"
              placeholder="zip code"
              label="Zip Code"
              name="zip_code"
              //   value={deviceDetails.quantity}
              //   onChange={(e) =>
              //     setDeviceDetails((prev) => ({
              //       ...prev,
              //       quantity: e.target.value,
              //     }))
              //   }
            />
          </section>
          <section className={styles.inputContainer}>
            <Input
              type="text"
              placeholder="city"
              label="City"
              name="city"
              //   value={deviceDetails.quantity}
              //   onChange={(e) =>
              //     setDeviceDetails((prev) => ({
              //       ...prev,
              //       quantity: e.target.value,
              //     }))
              //   }
            />
            <Input
              type="text"
              placeholder="state"
              label="State"
              name="state"
              //   value={deviceDetails.quantity}
              //   onChange={(e) =>
              //     setDeviceDetails((prev) => ({
              //       ...prev,
              //       quantity: e.target.value,
              //     }))
              //   }
            />
          </section>
          <section className={styles.inputContainer}>
            <Input
              type="text"
              placeholder="first name"
              label="Address"
              name="address"
              //   value={deviceDetails.quantity}
              //   onChange={(e) =>
              //     setDeviceDetails((prev) => ({
              //       ...prev,
              //       quantity: e.target.value,
              //     }))
              //   }
            />
          </section>
        </section>
      </section>
      <AddDevices />
    </section>
  );
};
export default OrderIndividual;
